import { render, staticRenderFns } from "./StrategyInfo.vue?vue&type=template&id=2605b81f&scoped=true&"
var script = {}
import style0 from "./StrategyInfo.vue?vue&type=style&index=0&id=2605b81f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605b81f",
  null
  
)

export default component.exports